import { render } from "./HomeContact.vue?vue&type=template&id=e0bc6570&scoped=true"
import script from "./HomeContact.vue?vue&type=script&lang=js"
export * from "./HomeContact.vue?vue&type=script&lang=js"

import "./HomeContact.vue?vue&type=style&index=0&id=e0bc6570&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0bc6570"]])

export default __exports__